<!--
  The (click) only stops propagation. The control is the ngbDropdownToggle
  button below.
-->
<div
  class="dropdown"
  ngbDropdown
  #dropdown="ngbDropdown"
  (click)="stopBubble($event)"
  [placement]="placement()"
  [container]="container()"
  [autoClose]="autoClose()"
  (openChange)="onOpenChange($event)"
>
  <span class="toggle-wrapper" ngbDropdownToggle>
    <ng-content select="[appDropdownButton]" />
  </span>
  <div ngbDropdownMenu>
    <ng-content select="[appDropdownItem]" />
  </div>
</div>
